import JwtDecode from 'jwt-decode'
import { POST } from '../API'
import {
  setAuthUser,
  setUserEmail,
  setUserProducts,
  setUserRole,
} from '../../redux/actions/auth'
import { history, store } from '../../redux/store'
import { SetLoader } from '../../redux/actions/loader'

const { dispatch } = store

const AuthUser = async (username, password) => {
  const body = { username, password }
  dispatch(SetLoader(true))
  const response = await POST('/spectro/users/login', '', body)
  dispatch(SetLoader(false))
  if (response.success) {
    localStorage.setItem('token', response.data.token)
    localStorage.setItem('products', JSON.stringify(response.data.products))
    const tokenDecoded = JwtDecode(response.data.token)
    dispatch(setAuthUser(true))
    dispatch(setUserEmail(tokenDecoded.sub))
    dispatch(setUserProducts(response.data.products))
    dispatch(setUserRole(tokenDecoded.role))
    history.push('/product')
  }
  return response
}

export { AuthUser }
